const NAMED_HTML_ENTITIES: Record<string, string> = {
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  nbsp: ' ',
  quot: '"'
};

const decodeHtmlEntities = (value: string): string => {
  let decodedValue = value;

  const MAX_UNICODE_CODE_POINT = 0x10ffff;

  const getValidCodePoint = (code: number, originalMatch: string): string => {
    if (!Number.isFinite(code) || code < 0 || code > MAX_UNICODE_CODE_POINT) {
      return originalMatch;
    }
    return String.fromCodePoint(code);
  };

  for (let i = 0; i < 2; i += 1) {
    const nextValue = decodedValue
      .replace(/&#x([0-9a-f]+);?/gi, (match, hexCode: string) =>
        getValidCodePoint(parseInt(hexCode, 16), match)
      )
      .replace(/&#(\d+);?/g, (match, decimalCode: string) =>
        getValidCodePoint(parseInt(decimalCode, 10), match)
      )
      .replace(
        /&([a-z]+);?/gi,
        (entity, entityName: string) =>
          NAMED_HTML_ENTITIES[entityName.toLowerCase()] ?? entity
      );

    if (nextValue === decodedValue) {
      break;
    }

    decodedValue = nextValue;
  }

  return decodedValue;
};

export default decodeHtmlEntities;
